import React from 'react';
import { motion } from 'framer-motion';

const WhyChooseUs = ({ data }) => {
    // Agar data nahi hai to render mat karo
    if (!data) return null;

    const listVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: {
                staggerChildren: 0.15,
                delayChildren: 0.2
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, x: -20 },
        visible: { opacity: 1, x: 0, transition: { duration: 0.5, ease: "easeOut" } }
    };

    return (
        <section className="w-full bg-[#f9fafc] py-16 lg:py-24 overflow-hidden relative">
            <div className="max-w-[1440px] mx-auto px-6 lg:px-[80px]">

                <motion.h2
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                    className="text-[#01386A] text-[20px] md:text-[30px] font-[600] font-sora lg:mb-[137px] mb-[40px]"
                >
                    {data.heading}
                </motion.h2>

                <div className="flex flex-col lg:flex-row items-center relative">

                    <motion.div
                        initial={{ opacity: 0, x: 50 }}
                        whileInView={{ opacity: 1, x: 0 }}
                        viewport={{ once: true }}
                        transition={{ duration: 0.8, ease: "easeOut" }}
                        className="w-full lg:w-full max-w-[656px] lg:absolute lg:right-0 relative z-0"
                    >
                        <div className="relative w-full aspect-[4/3] lg:h-[507px]">
                            <img
                                src={data.image}
                                alt="Why Choose Us"
                                className="w-full h-full object-cover"
                            />
                        </div>
                    </motion.div>

                    <motion.div
                        variants={listVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true }}
                        className="w-full lg:w-full max-w-[719px] bg-white p-8 lg:p-14 shadow-[0_10px_40px_rgba(0,0,0,0.08)] relative z-10 mt-[-50px] lg:mt-0 lg:ml-0"
                    >
                        <div className="flex flex-col gap-5">
                            {data.reasons.map((reason, index) => (
                                <motion.div key={index} variants={itemVariants} className="flex items-center gap-4">
                                    <span className="flex-shrink-0 flex items-center justify-center">
                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M9 18L15 12L9 6" stroke="#ED6800" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                        </svg>
                                    </span>
                                    <span className="text-[#49577A] text-[14px] lg:text-[16px] font-graphik font-[500] leading-tight">
                                        {reason}
                                    </span>
                                </motion.div>
                            ))}
                        </div>
                    </motion.div>

                </div>
            </div>
        </section>
    );
};

export default WhyChooseUs;